import { FC, ReactElement, memo, useState } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { SitesSearchingForm, useGetAllSitesQuery } from '@/modules/Sites';

import { SitesListView } from './SitesListView';

export const SitesListContainer: FC = memo(() => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    data: sitesListData,
    error: sitesListError,
    isLoading: isSitesListLoading,
    isFetching: isSitesListFetching,
    isError: isSitesListError
  } = useGetAllSitesQuery({ page: currentPage }, search)();

  return (
    <FallbackedLayout
      isLoading={ isSitesListLoading }
      error={ sitesListError }
      isError={ isSitesListError }
      data={ sitesListData }
    >
      { (sitesList): ReactElement => (
        <>
          <SitesSearchingForm search={ search } handleSubmitSearch={ setSearch }/>
          <SitesListView
            currentPage={ currentPage }
            sitesListItems={ sitesList.items }
            sitesListTotalItems={ sitesList.meta.totalItems }
            sitesListItemsPerPage={ sitesList.meta.itemsPerPage }
            isLoading={ isSitesListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
